module.exports = __webpack_public_path__ + "img/planewave_p.451d54f8.png";